import { createSelector } from 'reselect';
import ReceptaclesInPredesNotInCarditDetailsColumns
  from '../../containers/ReceptaclesInPredesNotInCarditDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptaclesInPredesNotInCarditDetailsColumns);
